import type { Task } from './api';

/** The default operational task order: most recently updated, then Task ID. */
export function compareTaskRecency(left: Task, right: Task): number {
  return right.updated_at - left.updated_at || right.id.localeCompare(left.id);
}

/** Returns a copy in the canonical deterministic recency order. */
export function sortTasksByRecency<T extends Task>(tasks: readonly T[]): T[] {
  return [...tasks].sort(compareTaskRecency);
}

/** Makes a user-selected table ordering deterministic without changing its primary sort. */
export function compareTasksWithIdTieBreak(
  primary: (left: Task, right: Task) => number,
  left: Task,
  right: Task,
): number {
  return primary(left, right) || right.id.localeCompare(left.id);
}
